<nav class="menu">
    <h4 class="menu__title">Profile management</h4>
    <ul>
        <li class="menu__option">
            <button class="menu__btn">Profile settings</button>
            <ul class="menu__sub-menu">
                <li><a 
                    [routerLink]="'./dashboard/profile'" 
                    routerLinkActive="current" 
                    [routerLinkActiveOptions]="{ exact: true }"
                    >My Profile</a></li>
                <li><a 
                    [routerLink]="'./dashboard/profile/reset-password'" 
                    routerLinkActive="current" 
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Password</a></li>
                <li><a 
                    [routerLink]="'./dashboard/profile/mfa'" 
                    routerLinkActive="current" 
                    [routerLinkActiveOptions]="{ exact: true }"
                    >Multi Factor Authentication</a></li>
            </ul>
        </li>
        <!-- <li class="menu__option">
            <button class="menu__btn">Othear option</button>
        </li>         -->
        <ng-container *ngIf="menu.length">
            <li class="menu__option">
                <button class="menu__btn">Available Apps</button>
                <ul class="menu__sub-menu">                
                    <ng-container *ngFor="let item of menu">
                        <li><a [href]="item.link" target="_blank">{{ item.label }}</a></li>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
    </ul>
</nav>
